module.exports = "/_next/static/images/DSC02769-2e4a8d026c748061fc8b5d1e79e54be1.jpg";